import { render, staticRenderFns } from "./Form_Parameter.vue?vue&type=template&id=8bffd704"
import script from "./Form_Parameter.vue?vue&type=script&lang=js"
export * from "./Form_Parameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports